import { createSelector } from 'reselect';
import { DEFAULT_ADULTS_FOR_SEARCH, MIN_ADULTS_FOR_BOATING } from '../../../Constants';
import { dateToDDMMYYYY } from '../../../utils/date';
import { arrayFromXToYInclusive } from '../../../utils/utils';

export const searchFormChannelIdSelector = (state) => state.search.form.channelId;
export const searchFormRegionIdSelector = (state) => state.search.form.regionId;
export const searchFormArrivalDateSelector = (state) => state.search.form.arrivalDate;

export const searchFormArrivalDateDateSelector = (state) => {
  const arrivalDate = state.search.form.arrivalDate;
  return arrivalDate ? new Date(new Date(arrivalDate).setHours(0, 0, 0, 0)) : undefined;
};
export const searchFormDurationSelector = (state) => state.search.form.duration;
export const searchFormAdultsSelector = (state) => state.search.form.adults || DEFAULT_ADULTS_FOR_SEARCH;
export const searchFormChildrenSelector = (state) => state.search.form.children;
export const searchFormUnder5sSelector = (state) => state.search.form.under5s;
export const searchFormCottageDatesSelector = (state) => state.search.form.cottageDates;
export const isPartyInvalidSelector = (state) => state.search.form.isPartyInvalid;
export const caravanNightsOptionsSelector = (state) => state.search.form.caravanNightsOptions;

export const getNightsAvailableSelector = createSelector(
  caravanNightsOptionsSelector,
  searchFormChannelIdSelector,
  searchFormRegionIdSelector,
  (caravanNights, channelId, regionId) => {
    switch (channelId) {
      case 'ukcaravan':
        return caravanNights?.[regionId];
      case 'uktouring':
        return arrayFromXToYInclusive(1, 21);
      case 'boats':
        return [...arrayFromXToYInclusive(3, 12), 14];
      case 'eurocaravan':
        return arrayFromXToYInclusive(3, 21);
      case 'ukcottages':
        return [...arrayFromXToYInclusive(1, 14), 21];
      case 'uklodge':
        return [2, 3, 4, 5, 6, 7, 10, 11, 14];
      default:
        return [2, 3, 4, 7, 10, 11, 14];
    }
  },
);

export const isDurationInvalidSelector = createSelector(
  getNightsAvailableSelector,
  searchFormDurationSelector,
  (nightsAvailable, duration) => {
    if (!duration || !Array.isArray(nightsAvailable)) return true;
    return !nightsAvailable.includes(duration);
  },
);

// Used on the guests select
export const getIsAdultsUIInvalidSelector = createSelector(
  [(_, adultsUI) => adultsUI, searchFormChannelIdSelector],
  (adultsUI, selectedChannelId) => {
    return selectedChannelId === 'boats' && adultsUI < MIN_ADULTS_FOR_BOATING;
  },
);

export const getIsAdultsInvalidSelector = createSelector(
  [searchFormAdultsSelector, searchFormChannelIdSelector],
  (adults, selectedChannelId) => {
    return selectedChannelId === 'boats' && adults < MIN_ADULTS_FOR_BOATING;
  },
);

export const searchFormPartySizeSelector = (state) => {
  return state.search.form.adults + state.search.form.children + state.search.form.under5s;
};

export const searchFormPetFriendlySelector = (state) => {
  return searchFormChannelIdSelector(state) === 'eurocaravan' ? undefined : state.search.form.petFriendly;
};

export const searchFormParamsSelector = (state) => ({
  channelId: searchFormChannelIdSelector(state),
  regionId: searchFormRegionIdSelector(state),
  arrivalDate: searchFormArrivalDateSelector(state),
  duration: searchFormDurationSelector(state),
  adults: searchFormAdultsSelector(state),
  children: searchFormChildrenSelector(state),
  under5s: searchFormUnder5sSelector(state),
  petFriendly: searchFormPetFriendlySelector(state),
});

export const searchFormRequestParamsSelector = (state) => ({
  channel: searchFormChannelIdSelector(state),
  region: searchFormRegionIdSelector(state),
  date: dateToDDMMYYYY(new Date(searchFormArrivalDateSelector(state))),
  partysize: searchFormAdultsSelector(state) + searchFormChildrenSelector(state) + searchFormUnder5sSelector(state),
  nights: searchFormDurationSelector(state),
  adults: searchFormAdultsSelector(state) || DEFAULT_ADULTS_FOR_SEARCH,
  children: searchFormChildrenSelector(state),
  infants: searchFormUnder5sSelector(state),
  dogs: searchFormPetFriendlySelector(state) ? 'y' : '',
});
